import { render } from "./EditWeek.vue?vue&type=template&id=70f8b301"
import script from "./EditWeek.vue?vue&type=script&lang=js"
export * from "./EditWeek.vue?vue&type=script&lang=js"

import "./EditWeek.vue?vue&type=style&index=0&id=70f8b301&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__